// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbRoot":"styles_breadcrumbRoot__6ZJxD","breadcrumbResponsive":"styles_breadcrumbResponsive__LK3D7"};